/* Equaliv · Avise-me quando chegar (produtos esgotados)
   Tudo nativo da Shopify:
   - inscrição = formulário de cliente ({% form 'customer' %}, snippet eq-notify-modal) com as etiquetas
     "avise-me" e "avise-me-<id da variante>"; o envio vai para um iframe escondido (a página não recarrega)
     e passa pela proteção anti-robô da própria Shopify;
   - aviso = Shopify Flow ("Produto voltou ao estoque" → procura clientes com a etiqueta → e-mail do Shopify Messaging
     → remove a etiqueta).
   Botões: qualquer elemento com [data-eq-notify="<id da variante>"] abre o modal (clique interceptado antes da compra).
   Botões que mudam de variante (página de produto, barra fixa, quick add) usam EQ.notify.set(botão, dados | null).
   Estado "Você será avisado": etiquetas do cliente logado (EQ_SETTINGS.notify.subs) + este navegador (localStorage). */
(() => {
  const EQ = window.EQ;
  if (!EQ || EQ.notify) return;
  const S = EQ.settings || {};
  const N = Object.assign(
    {
      enabled: true,
      label: 'Avise-me',
      doneLabel: 'Você será avisado',
      subs: [],
      email: '',
      name: '',
      phone: 'required',
      errorText: 'Não foi possível registrar o aviso. Confira os dados e tente de novo.',
      requiredText: 'Preencha este campo.',
      emailText: 'Digite um e-mail válido, como nome@email.com.',
      phoneText: 'Digite o celular com DDD, como (11) 98765-4321.',
      sendingText: 'Enviando…',
      timeoutText: 'A conexão demorou demais. Tente de novo.',
    },
    S.notify || {}
  );
  const LS = 'eq_notify_v1';
  const PENDING = 'eq_notify_pending';
  const store = {
    all() {
      try {
        return JSON.parse(localStorage.getItem(LS)) || {};
      } catch (_) {
        return {};
      }
    },
    add(id, email) {
      try {
        const o = this.all();
        o[id] = { e: email, t: Date.now() };
        localStorage.setItem(LS, JSON.stringify(o));
      } catch (_) {}
    },
    email(id) {
      const r = this.all()[id];
      return r ? r.e : '';
    },
  };
  const subs = new Set((N.subs || []).map(String));
  const isSub = (id) => !!id && (subs.has(String(id)) || !!store.all()[id]);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const fill = (tpl, d) =>
    String(tpl || '')
      .replace(/\[produto\]/g, '<strong>' + esc(d.title) + (d.variant ? ' · ' + esc(d.variant) : '') + '</strong>')
      .replace(/\[email\]/g, '<strong>' + esc(d.email || '') + '</strong>')
      .replace(/\[nome\]/g, esc(d.name || ''));

  /* ---------- botões ---------- */
  const paintBtn = (b) => {
    const id = b.dataset.eqNotify;
    if (!id) return;
    const on = isSub(id);
    if (!b.classList.contains('is-notify')) b.classList.add('is-notify');
    if (b.classList.contains('is-notified') !== on) b.classList.toggle('is-notified', on);
    if (b.disabled) b.disabled = false;
    const label = on ? N.doneLabel : N.label;
    // só escreve quando muda (o MutationObserver abaixo repinta a cada mudança no DOM)
    b.querySelectorAll('[data-eq-notify-text], [data-eq-add-label], [data-eq-add-label-m], [data-eq-bar-label], [data-eq-qa-submit-text]').forEach((t) => {
      if (t.textContent !== label) t.textContent = label;
    });
    if (b.hasAttribute('data-eq-notify-aria')) {
      const al = label + ': ' + (b.dataset.eqNotifyTitle || '');
      if (b.getAttribute('aria-label') !== al) b.setAttribute('aria-label', al);
    }
  };
  const paintAll = () => document.querySelectorAll('[data-eq-notify]').forEach(paintBtn);
  const dataOf = (b) => ({
    id: b.dataset.eqNotify,
    title: b.dataset.eqNotifyTitle || '',
    variant: b.dataset.eqNotifyVariant || '',
    img: b.dataset.eqNotifyImg || '',
    url: b.dataset.eqNotifyUrl || location.pathname,
  });

  /* ---------- modal ---------- */
  const root = document.getElementById('EqNotify');
  const $ = (sel) => root && root.querySelector(sel);
  const form = root && root.querySelector('#EqNotifyForm');
  const frame = $('[data-eq-ntf-frame]');
  let cur = null;
  let trigger = null;
  let sending = false;
  let dropPhone = false;
  let timer = 0;

  const step = (name) => {
    root.dataset.state = name;
    root.querySelectorAll('[data-eq-ntf-step]').forEach((s) => (s.hidden = s.dataset.eqNtfStep !== name));
    root.classList.toggle('is-check', name === 'check');
  };
  const setError = (msg) => {
    const box = $('[data-eq-ntf-error]');
    if (!box) return;
    box.textContent = msg || '';
    box.hidden = !msg;
  };
  const fieldError = (input, msg) => {
    const f = input && input.closest('.eq-field');
    if (!f) return;
    f.classList.toggle('is-error', !!msg);
    const h = f.querySelector('[data-eq-ntf-hint]');
    if (h) {
      h.textContent = msg || '';
      h.hidden = !msg;
    }
    if (msg) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  };
  const busy = (on) => {
    sending = on;
    const b = $('[data-eq-ntf-submit]');
    if (!b) return;
    b.classList.toggle('is-loading', on);
    if (on) b.setAttribute('aria-busy', 'true');
    else b.removeAttribute('aria-busy');
  };
  const fillProduct = (d) => {
    const img = $('[data-eq-ntf-img]');
    if (img) {
      img.hidden = !d.img;
      if (d.img) img.src = d.img;
    }
    $('[data-eq-ntf-name]').textContent = d.title;
    const v = $('[data-eq-ntf-var]');
    v.textContent = d.variant || '';
    v.hidden = !d.variant || d.variant === 'Default Title';
    const t = $('[data-eq-ntf-text]');
    if (t) t.innerHTML = fill(t.dataset.template, d);
  };

  const open = (d, from) => {
    if (!root || !d || !d.id) return;
    if (d.variant === 'Default Title') d.variant = '';
    cur = d;
    trigger = from || document.activeElement;
    dropPhone = false;
    busy(false);
    setError('');
    root.querySelectorAll('.eq-field').forEach((f) => fieldError(f.querySelector('input'), ''));
    fillProduct(d);
    if (isSub(d.id)) {
      const a = $('[data-eq-ntf-already-text]');
      a.innerHTML = fill(a.dataset.template, Object.assign({}, d, { email: N.email || store.email(d.id) }));
      step('already');
    } else {
      step('form');
      const login = $('[data-eq-ntf-login]');
      if (login) {
        const back = (d.url || location.pathname) + ((d.url || location.pathname).indexOf('?') < 0 ? '?' : '&') + 'variant=' + d.id + '&eq_notify=' + d.id;
        login.href = (S.loginUrl || '/account/login') + '?return_url=' + encodeURIComponent(back);
      }
    }
    // abre por cima do quick add (quando veio de lá)
    if (document.getElementById('EqQuickAdd') && document.getElementById('EqQuickAdd').classList.contains('is-open')) EQ.close('EqQuickAdd');
    EQ.open('EqNotify');
    const first = root.dataset.state === 'form' ? root.querySelector('.eq-ntf__fields input') || $('[data-eq-ntf-submit]') : root.querySelector('[data-eq-ntf-step="already"] .eq-btn');
    if (first) setTimeout(() => first.focus({ preventScroll: true }), 80);
  };

  const validate = () => {
    let ok = true;
    const nm = root.querySelector('.eq-ntf__fields [data-eq-ntf-name-input]');
    const em = root.querySelector('.eq-ntf__fields [data-eq-ntf-email]');
    const ph = $('[data-eq-ntf-phone]');
    if (nm) {
      const bad = !nm.value.trim();
      fieldError(nm, bad ? N.requiredText : '');
      if (bad) ok = false;
    }
    if (em) {
      const v = em.value.trim();
      const bad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      fieldError(em, bad ? (v ? N.emailText : N.requiredText) : '');
      if (bad) ok = false;
      else em.value = v;
    }
    if (ph) {
      const digits = ph.value.replace(/\D/g, '');
      const need = ph.required;
      const bad = (need || digits) && !(digits.length === 10 || digits.length === 11 || (digits.length >= 12 && digits.startsWith('55')));
      fieldError(ph, bad ? (digits ? N.phoneText : N.requiredText) : '');
      if (bad) ok = false;
      const out = $('[data-eq-ntf-phone-out]');
      if (out) out.value = !digits || dropPhone ? '' : '+' + (digits.length <= 11 ? '55' + digits : digits);
    }
    if (!ok) {
      const firstBad = root.querySelector('[aria-invalid="true"]');
      if (firstBad) firstBad.focus();
    }
    return ok;
  };

  const SENT = 'eq_notify_sent';
  const fields = () => {
    const em = root.querySelector('[data-eq-ntf-email]');
    const nm = root.querySelector('[data-eq-ntf-name-input]');
    const ph = root.querySelector('[data-eq-ntf-phone]');
    return { email: (em && em.value) || N.email, name: nm ? nm.value.trim() : N.name, phone: ph ? ph.value : '' };
  };
  /* estado real no servidor (cliente logado): ids das etiquetas avise-me-<id> */
  const serverIds = async () => {
    try {
      const html = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '?section_id=eq-notify-state&t=' + Date.now(), { credentials: 'same-origin' }).then((r) => r.text());
      const m = html.match(/data-eq-notify-state>([\s\S]*?)<\/script>/);
      const j = m ? JSON.parse(m[1]) : null;
      return j && j.logged ? (j.ids || []).map(String) : null;
    } catch (_) {
      return null;
    }
  };

  /* envio nativo (página inteira): a Shopify cuida da proteção anti-robô e devolve a página com ?customer_posted=true */
  const nativeSubmit = () => {
    try {
      sessionStorage.setItem(SENT, JSON.stringify({ d: cur, f: fields(), y: window.scrollY, t: Date.now(), dropPhone }));
    } catch (_) {}
    form.removeAttribute('target');
    form.action = '/contact#EqNotifyForm';
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  };

  const submit = () => {
    if (!cur || sending || !form) return;
    setError('');
    if (!validate()) return;
    const tags = $('[data-eq-ntf-tags]');
    tags.value = 'avise-me,avise-me-' + cur.id;
    form.noValidate = true;
    busy(true);
    clearTimeout(timer);
    if (!S.loggedIn) return nativeSubmit();
    // cliente logado: envia sem recarregar (iframe) e confirma lendo as etiquetas do cliente no servidor
    form.target = frame.name;
    timer = setTimeout(() => verify(true), 12000);
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  };

  let verifying = false;
  const verify = async (last) => {
    if (!sending || verifying || !cur) return;
    verifying = true;
    let ids = await serverIds();
    if (ids && !ids.includes(String(cur.id))) {
      await new Promise((r) => setTimeout(r, 1500));
      ids = await serverIds();
    }
    verifying = false;
    if (!sending) return;
    if (ids && ids.includes(String(cur.id))) return success();
    if (last || ids) {
      // não confirmou sem recarregar (ex.: a Shopify pediu verificação): segue pelo envio nativo
      clearTimeout(timer);
      return nativeSubmit();
    }
  };

  const success = (f) => {
    clearTimeout(timer);
    busy(false);
    const v = f || fields();
    const email = v.email || N.email;
    store.add(cur.id, email);
    if (S.loggedIn) subs.add(String(cur.id));
    const d = Object.assign({}, cur, { email, name: (v.name || N.name || '').split(' ')[0] });
    const t = $('[data-eq-ntf-done-title]');
    t.textContent = (t.dataset.template || '').replace(/\[nome\]/g, d.name || '').replace(/,\s*$/, '');
    const x = $('[data-eq-ntf-done-text]');
    x.innerHTML = fill(x.dataset.template, d);
    step('done');
    root.classList.remove('is-celebrate');
    void root.offsetWidth;
    root.classList.add('is-celebrate');
    setTimeout(() => {
      const done = root.querySelector('[data-eq-ntf-step="done"]');
      if (done) done.focus({ preventScroll: true });
    }, 60);
    paintAll();
    EQ.emit('eq:notify:subscribed', { id: cur.id });
  };

  const fail = (msg) => {
    clearTimeout(timer);
    busy(false);
    step('form');
    setError(msg || N.errorText);
  };

  if (frame) {
    frame.addEventListener('load', () => {
      if (!sending) return;
      let blank = false;
      try {
        blank = frame.contentWindow.location.href === 'about:blank';
      } catch (_) {}
      if (!blank) verify(false);
    });
  }

  if (root) {
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-eq-ntf-submit]')) {
        e.preventDefault();
        submit();
      }
      if (e.target.closest('[data-eq-ntf-again]')) {
        e.preventDefault();
        step('form');
        const em = root.querySelector('.eq-ntf__fields [data-eq-ntf-email]');
        if (em) em.focus();
      }
    });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('.eq-ntf__fields input')) {
        e.preventDefault();
        submit();
      }
    });
    root.addEventListener('input', (e) => {
      const ph = e.target.closest('[data-eq-ntf-phone]');
      if (ph) {
        const d = ph.value.replace(/\D/g, '').slice(0, 11);
        let o = d;
        if (d.length > 2) o = '(' + d.slice(0, 2) + ') ' + d.slice(2);
        if (d.length > 7) o = '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length - 4) + '-' + d.slice(-4);
        ph.value = o;
      }
      if (e.target.closest('.eq-field.is-error')) fieldError(e.target, '');
    });
    // devolve o foco ao botão que abriu
    new MutationObserver(() => {
      if (root.getAttribute('aria-hidden') === 'true') {
        clearTimeout(timer);
        if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
      }
    }).observe(root, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* clique em qualquer [data-eq-notify]: abre o modal no lugar da compra */
  document.addEventListener(
    'click',
    (e) => {
      const b = e.target.closest('[data-eq-notify]');
      if (!b || !root) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      open(dataOf(b), b);
    },
    true
  );

  /* API para botões dinâmicos */
  EQ.notify = {
    open,
    isSub,
    label: (id) => (isSub(id) ? N.doneLabel : N.label),
    /* liga (dados) ou desliga (null) o modo avise-me num botão de compra */
    set(btn, d) {
      if (!btn) return;
      if (d && d.id && N.enabled !== false) {
        btn.dataset.eqNotify = d.id;
        btn.dataset.eqNotifyTitle = d.title || '';
        if (d.variant && d.variant !== 'Default Title') btn.dataset.eqNotifyVariant = d.variant;
        else delete btn.dataset.eqNotifyVariant;
        if (d.img) btn.dataset.eqNotifyImg = d.img;
        if (d.url) btn.dataset.eqNotifyUrl = d.url;
        paintBtn(btn);
      } else {
        delete btn.dataset.eqNotify;
        btn.classList.remove('is-notify', 'is-notified');
      }
    },
    paint: paintAll,
  };

  /* repinta quando o DOM muda (carrinho, quick add, filtros, busca) */
  let raf = 0;
  new MutationObserver(() => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      paintAll();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* volta do login: inscreve na hora */
  const boot = () => {
    paintAll();
    const params = new URLSearchParams(location.search);
    /* volta do envio nativo */
    let sent = null;
    try {
      sent = JSON.parse(sessionStorage.getItem(SENT) || 'null');
      sessionStorage.removeItem(SENT);
    } catch (_) {}
    if (sent && sent.d && Date.now() - sent.t < 10 * 60 * 1000) {
      const posted = params.get('customer_posted') === 'true';
      if (posted) {
        params.delete('customer_posted');
        const q = params.toString();
        history.replaceState(history.state, '', location.pathname + (q ? '?' + q : ''));
      }
      if (typeof sent.y === 'number') window.scrollTo(0, sent.y);
      open(sent.d);
      if (posted) return success(sent.f);
      // voltou sem confirmação: mostra o erro da Shopify (se houver) e mantém o que a pessoa digitou
      const box = root && root.querySelector('[data-eq-ntf-error]');
      const msg = box ? box.textContent.replace(/\s+/g, ' ').trim() : '';
      const set = (sel, v) => {
        const i = root.querySelector(sel);
        if (i && v) i.value = v;
      };
      set('.eq-ntf__fields [data-eq-ntf-name-input]', sent.f && sent.f.name);
      set('.eq-ntf__fields [data-eq-ntf-email]', sent.f && sent.f.email);
      set('[data-eq-ntf-phone]', sent.f && sent.f.phone);
      if (msg && /phone|telefone|celular/i.test(msg) && !sent.dropPhone && root.querySelector('[data-eq-ntf-phone-out]')) {
        // telefone já usado em outro cadastro: inscreve só com o e-mail
        dropPhone = true;
        return submit();
      }
      return fail(msg ? N.errorText + ' (' + msg + ')' : N.errorText);
    }
    const id = params.get('eq_notify');
    if (!id) return;
    params.delete('eq_notify');
    const qs = params.toString();
    history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    let d = null;
    try {
      d = JSON.parse(sessionStorage.getItem(PENDING) || 'null');
      sessionStorage.removeItem(PENDING);
    } catch (_) {}
    if (!d || String(d.id) !== String(id)) {
      const b = document.querySelector('[data-eq-notify="' + id.replace(/\D/g, '') + '"]');
      d = b ? dataOf(b) : null;
    }
    if (!d) return;
    open(d);
    if (S.loggedIn && !isSub(d.id)) submit();
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-eq-ntf-login]');
    if (a && cur) {
      try {
        sessionStorage.setItem(PENDING, JSON.stringify(cur));
      } catch (_) {}
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
